import { useParams } from 'react-router-dom'

import { AsyncBlock } from '../components/AsyncBlock'
import { ProjectHeading } from '../components/ProjectHeading'
import { api, type ScheduleTask } from '../lib/api'
import { fmtDate, humanize, statusClass } from '../lib/format'
import { useAsync } from '../lib/useAsync'

function TaskRow({ task }: { task: ScheduleTask }): JSX.Element {
  const start = task.actual_start ?? task.planned_start
  const finish = task.actual_finish ?? task.planned_finish
  return (
    <li className="row">
      <div className="row-main">
        <span className="row-title">{task.display_name}</span>
        {task.phase && <span className="row-sub">{humanize(task.phase)}</span>}
      </div>
      <div className="row-meta">
        <span className="row-dates">
          {fmtDate(start)} → {fmtDate(finish)}
        </span>
        <span className={`badge badge-${statusClass(task.status)}`}>
          {humanize(task.status)}
        </span>
      </div>
    </li>
  )
}

export function SchedulePage(): JSX.Element {
  const { projectId = '' } = useParams()
  const state = useAsync(() => api.schedule(projectId), `schedule-${projectId}`)
  return (
    <div className="page">
      <ProjectHeading projectId={projectId} title="Schedule" />
      <AsyncBlock
        state={state}
        isEmpty={(d) => d.tasks.length === 0}
        emptyText="No schedule items to show yet."
      >
        {(d) => (
          <ul className="row-list">
            {d.tasks.map((t) => (
              <TaskRow key={t.id} task={t} />
            ))}
          </ul>
        )}
      </AsyncBlock>
    </div>
  )
}
